/* THE FIT SOCIETY — SHARE THE SOCIETY (attribution + panier + partage) */
(function () {
  'use strict';
  var SUPA = 'https://buzppaxdjkjmozzhxxqb.supabase.co/functions/v1';
  var LS_KEY = 'tfs_support';
  var DAYS = 30;

  /* ---------- utils ---------- */
  function cleanCode(c) { return String(c || '').toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 24); }
  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  function setAttrs(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }
  function validate(code) {
    return fetch(SUPA + '/society-click?code=' + encodeURIComponent(code))
      .then(function (r) { return r.json(); }).catch(function () { return { valid: false }; });
  }
  function beacon(code) {
    try {
      navigator.sendBeacon(SUPA + '/society-click', new Blob([JSON.stringify({ code: code, path: location.pathname })], { type: 'application/json' }));
    } catch (e) { /* silencieux */ }
  }
  function store(code) { try { localStorage.setItem(LS_KEY, JSON.stringify({ code: code, ts: Date.now() })); } catch (e) {} }
  function stored() {
    try {
      var d = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (d && d.code && (Date.now() - d.ts) < DAYS * 864e5) return d.code;
    } catch (e) {}
    return null;
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'tfs-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 500); }, 3800);
  }

  /* ---------- 1. capture du lien ?support= ---------- */
  function capture() {
    var p = new URLSearchParams(location.search);
    var code = cleanCode(p.get('support'));
    if (code) {
      validate(code).then(function (v) {
        if (!v.valid) return;
        getCart().then(function (cart) {
          var a = cart.attributes || {};
          if (a.support_source === 'manual' && a.support_code && a.support_code !== code) return; /* le choix manuel prime */
          setAttrs({ support_code: code, support_source: 'link', support_landing: location.pathname, support_ts: new Date().toISOString() })
            .then(function () { renderSlots(); });
          store(code); beacon(code);
          toast('Vous soutenez ' + code + ' ✓');
        });
        p.delete('support');
        var q = p.toString();
        history.replaceState({}, '', location.pathname + (q ? '?' + q : '') + location.hash);
      });
      return;
    }
    /* ré-application silencieuse si panier neuf */
    var mem = stored();
    if (mem) {
      getCart().then(function (cart) {
        var a = cart.attributes || {};
        if (!a.support_code) {
          validate(mem).then(function (v) {
            if (v.valid) setAttrs({ support_code: mem, support_source: 'link' }).then(renderSlots);
          });
        }
      });
    }
  }

  /* ---------- 2. bloc panier ---------- */
  function slotHtml(code) {
    if (code) {
      return '<p class="tfs-support__applied">Vous soutenez <strong>' + code + '</strong> <span aria-hidden="true">✓</span>' +
        ' <button type="button" class="tfs-support__edit" data-tfs-edit>Modifier</button></p>' +
        '<div class="tfs-support__form" hidden data-tfs-form>' + formHtml(code) + '</div>';
    }
    return '<details class="tfs-support__details"><summary>Ajouter un code de soutien</summary><div class="tfs-support__form">' + formHtml('') + '</div></details>';
  }
  function formHtml(v) {
    return '<label class="sr-only" for="tfs-code-input">Code de soutien</label>' +
      '<div class="tfs-support__row"><input id="tfs-code-input" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Code" value="' + v + '" data-tfs-input>' +
      '<button type="button" class="tfs-support__apply" data-tfs-apply>Valider</button></div>' +
      (v ? '<button type="button" class="tfs-support__remove" data-tfs-remove>Retirer le soutien</button>' : '') +
      '<p class="tfs-support__error" role="alert" hidden data-tfs-error>Ce code est introuvable ou inactif.</p>';
  }
  function renderSlots() {
    var slots = document.querySelectorAll('[data-tfs-support]');
    if (!slots.length) return;
    getCart().then(function (cart) {
      var code = cleanCode((cart.attributes || {}).support_code);
      slots.forEach(function (s) {
        s.innerHTML = slotHtml(code);
        s.querySelectorAll('[data-tfs-edit]').forEach(function (b) {
          b.addEventListener('click', function () { s.querySelector('[data-tfs-form]').hidden = false; b.closest('p').hidden = true; });
        });
        var apply = s.querySelector('[data-tfs-apply]');
        if (apply) apply.addEventListener('click', function () {
          var input = s.querySelector('[data-tfs-input]');
          var err = s.querySelector('[data-tfs-error]');
          var c = cleanCode(input.value);
          if (!c) { err.hidden = false; return; }
          apply.disabled = true;
          validate(c).then(function (v) {
            apply.disabled = false;
            if (!v.valid) { err.hidden = false; input.setAttribute('aria-invalid', 'true'); return; }
            setAttrs({ support_code: c, support_source: 'manual' }).then(function () {
              store(c); toast('Vous soutenez ' + c + ' ✓'); renderSlots();
            });
          });
        });
        var rem = s.querySelector('[data-tfs-remove]');
        if (rem) rem.addEventListener('click', function () {
          setAttrs({ support_code: '', support_source: '', support_landing: '', support_ts: '' }).then(function () {
            try { localStorage.removeItem(LS_KEY); } catch (e) {}
            renderSlots();
          });
        });
      });
    });
  }
  function injectCartPageSlot() {
    if (!document.body.classList.contains('template-cart')) return;
    if (document.querySelector('.template-cart-slot')) return;
    var btn = document.querySelector('form[action*="/cart"] button[name="checkout"], button[name="checkout"]');
    if (!btn) return;
    var d = document.createElement('div');
    d.className = 'tfs-support template-cart-slot';
    d.setAttribute('data-tfs-support', '');
    var target = btn.closest('form') || btn.parentElement;
    target.parentElement.insertBefore(d, target);
  }

  /* ---------- 3. SHARE THE SOCIETY (MY SOCIETY) ---------- */
  function initShare() {
    var root = document.querySelector('[data-tfs-share]');
    if (!root) return;
    var CODE = root.getAttribute('data-code');
    var LINK = root.getAttribute('data-link');
    var NUM = root.getAttribute('data-num');
    var FOUNDING = root.getAttribute('data-founding') === '1';
    var SHARE_TEXT = 'Je fais partie de THE FIT SOCIETY. Rejoins la Society avec mon lien.';
    var tpl = 'noir';

    var INK = '#0E0E0D', PAPER = '#F2EDE6', MIN = '#8A8782';
    function sp(s) { return s.split('').join(' '); }
    function drawStory() {
      var W = 1080, H = 1920;
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d');
      var dark = tpl === 'noir';
      var bg = dark ? INK : PAPER, fg = dark ? PAPER : INK, mn = dark ? MIN : '#6B6964';
      x.fillStyle = bg; x.fillRect(0, 0, W, H);
      x.strokeStyle = dark ? 'rgba(242,237,230,.22)' : 'rgba(14,14,13,.18)';
      x.lineWidth = 2; x.strokeRect(44, 44, W - 88, H - 88);
      var P = 112;
      x.fillStyle = fg; x.font = '600 30px Assistant, sans-serif';
      x.fillText(sp('THE FIT SOCIETY'), P, 168);
      x.fillStyle = mn; x.font = '300 24px Assistant, sans-serif';
      x.textAlign = 'right'; x.fillText(sp('TFS / ID'), W - P, 168); x.textAlign = 'left';
      x.fillStyle = mn; x.font = '400 24px Assistant, sans-serif';
      x.fillRect(P, 470, 66, 2);
      x.fillText(sp(FOUNDING ? 'FOUNDING 50' : 'SOCIETY MEMBER'), P + 90, 478);
      x.fillStyle = fg;
      x.font = 'italic 400 86px "Playfair Display", serif';
      x.fillText('Nº', P, 640);
      x.font = '500 210px "Playfair Display", serif';
      x.fillText(NUM, P + 130, 690);
      x.fillStyle = mn; x.font = '400 26px Assistant, sans-serif';
      x.fillText(sp('SUPPORT CODE'), P, 850);
      x.fillStyle = fg; x.font = '600 78px Assistant, sans-serif';
      x.fillText(CODE, P, 950);
      x.fillStyle = fg; x.font = 'italic 400 46px "Playfair Display", serif';
      x.fillText('Join the Society', P, 1120);
      x.fillStyle = mn; x.font = '300 27px Assistant, sans-serif';
      x.fillText('Chaque 24 du mois. Un chapitre.', P, 1175);
      x.setLineDash([10, 10]);
      x.strokeStyle = mn; x.lineWidth = 2;
      var zw = 520, zh = 128, zx = (W - zw) / 2, zy = 1300;
      x.strokeRect(zx, zy, zw, zh);
      x.setLineDash([]);
      x.fillStyle = mn; x.font = '300 24px Assistant, sans-serif';
      x.textAlign = 'center';
      x.fillText('Place ton sticker lien ici', W / 2, zy + zh / 2 + 8);
      x.textAlign = 'left';
      x.strokeStyle = dark ? 'rgba(242,237,230,.22)' : 'rgba(14,14,13,.18)';
      x.beginPath(); x.moveTo(P, H - 190); x.lineTo(W - P, H - 190); x.stroke();
      x.fillStyle = fg; x.font = '300 24px Assistant, sans-serif';
      x.fillText(sp('EST. 2026'), P, H - 128);
      x.fillStyle = mn; x.textAlign = 'right';
      x.fillText(sp('BRUSSELS'), W - P, H - 128); x.textAlign = 'left';
      return c;
    }
    function withFonts(fn) {
      Promise.all(['500 100px "Playfair Display"', 'italic 400 60px "Playfair Display"', '600 30px Assistant', '300 26px Assistant']
        .map(function (f) { return document.fonts.load(f); })).then(fn);
    }
    function refreshPreview() {
      withFonts(function () {
        var img = root.querySelector('[data-tfs-preview]');
        if (img) img.src = drawStory().toDataURL('image/jpeg', 0.9);
      });
    }
    function toBlob(cb) { withFonts(function () { drawStory().toBlob(cb, 'image/png'); }); }
    function download() {
      toBlob(function (blob) {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'TFS-' + CODE + '-story.png';
        document.body.appendChild(a); a.click(); a.remove();
      });
    }
    function copy(text, msg) {
      navigator.clipboard.writeText(text).then(function () { toast(msg); }, function () { toast('Copie impossible — sélectionne le texte'); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tfs-action]');
      if (!b) return;
      var act = b.getAttribute('data-tfs-action');
      if (act === 'share') {
        toBlob(function (blob) {
          var file = new File([blob], 'TFS-' + CODE + '-story.png', { type: 'image/png' });
          var payload = { files: [file], text: SHARE_TEXT + ' ' + LINK };
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            copy(LINK, 'Lien copié — ajoute-le en sticker à ta story');
            navigator.share(payload).catch(function () {});
          } else {
            download(); copy(LINK, 'Story téléchargée + lien copié — ajoute le sticker lien');
          }
        });
      }
      if (act === 'download') download();
      if (act === 'copy-link') copy(LINK, 'Lien copié ✓');
      if (act === 'copy-code') copy(CODE, 'Code copié ✓');
      if (act === 'tpl') {
        tpl = b.getAttribute('data-tpl');
        root.querySelectorAll('[data-tfs-action="tpl"]').forEach(function (t) { t.classList.toggle('is-active', t === b); });
        refreshPreview();
      }
    });
    refreshPreview();
    fetch(SUPA + '/society-stats?code=' + encodeURIComponent(CODE))
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (s.error) return;
        var eur = function (c) { return (c / 100).toLocaleString('fr-BE', { style: 'currency', currency: 'EUR' }); };
        var el = function (k, v) { var n = root.querySelector('[data-stat="' + k + '"]'); if (n) n.textContent = v; };
        el('clicks', s.clicks); el('orders', s.orders);
        el('approved', eur(s.approved_cents + s.paid_cents)); el('pending', eur(s.pending_cents));
        var w = root.querySelector('[data-tfs-impact]'); if (w) w.hidden = false;
      }).catch(function () {});
  }

  var css = '.tfs-toast{position:fixed;left:50%;bottom:28px;transform:translate(-50%,16px);background:#0E0E0D;color:#F2EDE6;padding:13px 22px;font-size:13.5px;letter-spacing:.06em;opacity:0;transition:opacity .4s,transform .4s;z-index:999;pointer-events:none;max-width:90vw;text-align:center}' +
    '.tfs-toast.is-in{opacity:1;transform:translate(-50%,0)}' +
    '.tfs-support{margin:14px 0;font-size:13.5px}' +
    '.tfs-support__applied{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin:0}' +
    '.tfs-support__edit,.tfs-support__remove{background:none;border:none;text-decoration:underline;cursor:pointer;font:inherit;color:inherit;opacity:.7;padding:4px}' +
    '.tfs-support__details summary{cursor:pointer;opacity:.75;padding:6px 0;list-style-position:inside}' +
    '.tfs-support__row{display:flex;gap:8px;margin-top:10px}' +
    '.tfs-support__row input{flex:1;min-width:0;padding:11px 12px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;text-transform:uppercase;letter-spacing:.08em}' +
    '.tfs-support__apply{padding:11px 18px;background:#0E0E0D;color:#F2EDE6;border:1px solid #0E0E0D;cursor:pointer;font:inherit;font-size:12px;letter-spacing:.14em;text-transform:uppercase}' +
    '.tfs-support__error{color:#8C1D33;margin:8px 0 0}';
  var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

  function init() { capture(); injectCartPageSlot(); renderSlots(); initShare(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
